import 'whatwg-fetch';
import { receiveAllBots, showRequestFailureAlert } from 'actions/ApiAction';

import { BASE_URL } from '../const';
import { MogamboRequest, authenticate, captureException } from './index';
import { mogamboRequestV2, mogamboRequestV3, getEncodedStr } from './utils';

export const getAllBots = (callback) => {
  const url = `${BASE_URL}all_bots/`;
  const request = MogamboRequest(url, 'GET');

  fetch(request)
    .then((response) => {
      const contentType = response.headers.get('content-type');
      if (contentType && contentType.indexOf('application/json') !== -1) {
        return response.json().then((json) => {
          authenticate(json);
          if (json.success) {
            receiveAllBots(json.body, json.meta, callback);
          } else {
            showRequestFailureAlert(json.error || 'Error fetching all Bots');
          }
        });
      }
      showRequestFailureAlert('Error fetching all Bots');
    })
    .catch(captureException);
};

export const createBot = async (data) => {
  const url = `${BASE_URL}/domain/data/`;
  const response = await mogamboRequestV2(url, 'POST', data);
  if (response.success) {
    return Promise.resolve(response);
  }
  return Promise.reject(response);
};

export const fetchTestConfiguration = async (paramDict) => {
  const params = getEncodedStr(paramDict);
  const url = `${BASE_URL}domain/test?${params}`;
  const response = await mogamboRequestV2(url, 'GET');
  if (response.success) {
    localStorage.setItem('testConfigData', JSON.stringify(response.body));
    return Promise.resolve(response);
  }
  return Promise.reject(response);
};

export const getBotSummary = async (id) => {
  const url = `${BASE_URL}transfer/data/domain/${id}`;
  const response = await mogamboRequestV2(url, 'GET');
  if (response.success) {
    return Promise.resolve(response);
  }
  return Promise.reject(response);
};

export const getDomainData = async (id) => {
  const url = `${BASE_URL}domain/data/${id}`;
  const response = await mogamboRequestV2(url, 'GET');
  if (response.success) {
    return Promise.resolve(response);
  }
  return Promise.reject(response);
};

export const addLanguageToBot = async (domainId, data) => {
  const url = `${BASE_URL}domain/languages/${domainId}/`;
  const response = await mogamboRequestV2(url, 'POST', data);
  if (response.success) {
    return Promise.resolve(response);
  }
  return Promise.reject(response);
};

export const getDomainStats = async (id) => {
  const url = `${BASE_URL}domain/stats/${id}/`;
  const response = await mogamboRequestV2(url, 'GET');
  if (response.success) {
    return Promise.resolve(response);
  }
  return Promise.reject(response);
};

export const getDomainStatus = async (id) => {
  const url = `${BASE_URL}domain/status/${id}/`;
  const response = await mogamboRequestV2(url, 'GET');
  if (response.success) {
    return Promise.resolve(response);
  }
  return Promise.reject(response);
};

export const translateBot = async (domainName, fromCode, toCode) => {
  const url = `${BASE_URL}domain/translate/${domainName}/`;
  const response = await mogamboRequestV2(url, 'POST', {
    from_language: fromCode,
    to_language: toCode,
  });
  if (response.success) {
    return Promise.resolve(response);
  }
  return Promise.reject(response);
};

export const getVersioning = (domainName, signal) => {
  const url = `${BASE_URL}preview_changes/${domainName}/`;
  return mogamboRequestV3(url, 'GET', {}, signal);
};

export const validatePreviewTransfer = (domainName, previewDate) => {
  const url = `${BASE_URL}validate_preview/${domainName}/?preview_created_at=${previewDate}`;
  return mogamboRequestV3(url, 'GET');
};

export const getTranslations = (payload) => {
  const url = `${BASE_URL}bot_responses/translate/`;
  return mogamboRequestV3(url, 'POST', payload);
};

export const getFollowupMessage = (domainId) => {
  const url = `${BASE_URL}v1/domains/${domainId}/webguide_data/`;
  return mogamboRequestV3(url, 'GET');
};

export const saveFollowupMessage = (domainId, payload) => {
  const url = `${BASE_URL}v1/domains/${domainId}/webguide_data/`;
  return mogamboRequestV3(url, 'POST', payload);
};

export const getBotVersionTimeline = (domainId, value) => {
  const url = `${BASE_URL}domains/${domainId}/versions?timeline=${value}`;
  return mogamboRequestV3(url, 'GET');
};

export const getBotVersionWorkingCopy = (domainId) => {
  const url = `${BASE_URL}domains/${domainId}/versions?working_copy=true`;
  return mogamboRequestV3(url, 'GET');
};

export const getLatestBotVersionsData = (domainId) => {
  const url = `${BASE_URL}domains/${domainId}/versions?latest=true`;
  return mogamboRequestV3(url, 'GET');
};

export const createOrRestoreVersion = (domainId, action, payload) => {
  const commonUrl = `${BASE_URL}domains/${domainId}/versions?`;
  const url =
    action === 'create' ? `${commonUrl}action=1` : `${commonUrl}action=2`;

  return mogamboRequestV3(url, 'POST', payload);
};

export const createABTest = (domainId, payload) => {
  const url = `${BASE_URL}domains/${domainId}/ab_test`;
  return mogamboRequestV3(url, 'POST', payload);
};

export const updateABTestSplitDetails = (domainId, abTestId, payload) => {
  const url = `${BASE_URL}domains/${domainId}/ab_test?test_id=${abTestId}`;
  return mogamboRequestV3(url, 'PUT', payload);
};

export const getTwilioToken = (domainId, demo) => {
  let url = `${BASE_URL.replace(
    '/mogambo_api',
    ''
  )}ai_agents/access_token/?domain_id=${domainId}`;
  if (demo) {
    url = `${url}&_demo=true`;
  }

  return fetch(url);
};

export const getSocketUrl = (domainId, demo, platform) => {
  let url = `${BASE_URL.replace(
    '/mogambo_api',
    ''
  )}ai_agents/${platform}/inbound-call`;
  if (demo) {
    url = `${url}?_demo=true`;
  }

  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ domain_id: domainId }),
  });
};
